import { ColliState } from '@frontend/colli/types';
import { EntityStatusBadgeVariant } from '@frontend/common';
import React from 'react';

import { ColliStateBadgeProps } from './colli-state-badge.component';

interface ViewProps {
    displayName: React.ReactNode;
    variant: EntityStatusBadgeVariant;
}

const useColliStateBadge = (props: ColliStateBadgeProps): ViewProps => {
    return {
        displayName: ColliState.getByValue(props.state)?.displayName || 'Unknown',
        variant: ColliState.getBadgeVariant(props.state)
    };
};

export default useColliStateBadge;
